import React, { useState } from 'react';
import FormulaModalButton from 'components/buttons/formula-modal';
import AdditionalModal from './additional-mandate-modal';
import { NON_STANDARD_RISK } from './types';

export interface IAdditionalMandateInterface {
  nonStandardRisksDefault:
    | { options: { radioName: string; selected: boolean }[]; name: string; displayName: string }[]
    | undefined;
  updateDealField: Function;
  getDealEvaluation: Function;
  selectedNonStandardRisk: string[] | undefined;
}

export default ({
  nonStandardRisksDefault,
  updateDealField,
  getDealEvaluation,
  selectedNonStandardRisk,
}: IAdditionalMandateInterface) => {
  const [enableModal, setEnableModal] = useState(false);
  const isNonStandardRisk = selectedNonStandardRisk ? selectedNonStandardRisk.length > 0 : false;
  return (
    <>
      <FormulaModalButton
        complete={isNonStandardRisk}
        enabled={isNonStandardRisk}
        label={NON_STANDARD_RISK}
        onGeneralClick={() => {
          setEnableModal(true);
        }}
      />
      {enableModal && (
        <AdditionalModal
          nonStandardRisksDefault={nonStandardRisksDefault}
          setEnableModal={setEnableModal}
          enableModal={enableModal}
          updateDealField={updateDealField}
          getDealEvaluation={getDealEvaluation}
        />
      )}
    </>
  );
};
